<div
  class="img-container bg-theme p-2 h-100 d-flex align-items-center justify-content-center"
>
  <img
    src="./assets/images/brand_white.png"
    alt="Logomarca da Union Solutions"
    loading="lazy"
  />
</div>